'use client'

import React from 'react'

export interface SubNavigationItemProps {
    children: React.ReactNode
}

export const SubNavigationItem = ({ children }: SubNavigationItemProps) => {
    return (
        <div
            className="main-navigation__subnavigation-item whitespace-nowrap min-w-full flex w-full text-left py-3 px-4 text-text-primary hover:cursor-pointer hover:bg-accent-opacity-100 active:bg-accent-opacity-200"
            data-testid="sub-menu-item"
        >
            {children}
        </div>
    )
}
